import { Combinator } from '../types';
import { createBlankQuery } from './createBlankQuery';
import { createBlankCriteriaForCatalog } from './createBlankCriteriaForCatalog';

export const createBlankQueryForCatalog = (combinator: Combinator) =>
  createBlankQuery({
    searchQueries: [createBlankCriteriaForCatalog(combinator)],
  });
